import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { SocialPostDetailsComponent } from '../social-post-details/social-post-details.component';
@Component({
  imports: [SocialPostDetailsComponent],
  selector: 'app-youtube-vod-details',
  templateUrl: './youtube-vod-details.component.html',
})
export class YoutubeVodDetailsComponent extends DeliverableAnalyticsContentDirective {}
